<mat-form-field class="w-full" [style.fontSize]="'10px'" appearance="outline">
  <mat-label>Values</mat-label>
  <mat-chip-list #chipList aria-label="Values" [multiple]="false">
    <mat-chip
      *ngFor="let value of valuesControl.value; trackBy: trackByValue"
      [selectable]="true"
      class="filter-chip"
      [removable]="true"
      (removed)="removeChip(value)"
    >
      {{ value }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    <ng-content select="input"></ng-content>
  </mat-chip-list>
  <ng-content select="mat-autocomplete"></ng-content>
  <ng-content select="mat-hint"></ng-content>
  <ng-content select="[matSuffix]"></ng-content>
</mat-form-field>
